import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Box, TextInput, Switch, Group, Button } from '@mantine/core';
import { useForm } from "@mantine/form";
import axios from 'axios';
import type { IResponse } from "../../types/api";
import { showMessage } from "../../lib/notification";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { IUserSubscription, PaymentType } from "./types";
import produce from "immer";
import { paymentTypes } from "./constants";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";

interface FormValues extends Pick<IUserSubscription, 'userId' | 'subscriptionId' | 'startDate' | 'endDate' | 'orderId' | 'createdUserName' | 'isActive'> {
    paidBy: PaymentType | '';
}

const EditUserSubscription = () => {

    const { state: id = null } = useLocation();

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            createdUserName: "",
            endDate: "",
            isActive: false,
            orderId: "",
            paidBy: "",
            startDate: "",
            subscriptionId: "",
            userId: ""
        },
    });

    React.useEffect(() => {
        const fetchData = async () => {
            const { data } = await axios.get<IResponse<IUserSubscription>>(`${API_ROUTE}/${id}`);
            form.setValues(
                produce(data.result, draft => {
                    // @ts-ignore
                    draft.paidBy = paymentTypes?.[draft?.paidBy] ?? draft.paidBy;
                })
            );
            form.resetDirty();
        }
        void fetchData();
    }, []);

    const handleSubmit = async (values: FormValues) => {
        const { data } = await axios.post<IResponse<any>>(`${API_ROUTE}/${id}`, values);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green')
        } else {
            showMessage('Алдаа гарлаа')
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} засах`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto">

                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <TextInput
                            withAsterisk
                            label="Хэрэглэгч"
                            disabled
                            {...form.getInputProps('userId')}
                        />

                        <TextInput
                            withAsterisk
                            disabled
                            label="Багц"
                            {...form.getInputProps('subscriptionId')}
                        />

                        <TextInput
                            withAsterisk
                            disabled
                            label="Эхлэх өдөр"
                            {...form.getInputProps('startDate')}
                        />

                        <TextInput
                            withAsterisk
                            label="Дуусах өдөр"
                            disabled
                            {...form.getInputProps('endDate')}
                        />

                        <TextInput
                            withAsterisk
                            disabled
                            label="Нэхэмжлэх дугаар"
                            {...form.getInputProps('orderId')}
                        />

                        <TextInput
                            withAsterisk
                            label="Төлбөр төлсөн хэрэгсэл"
                            disabled
                            {...form.getInputProps('paidBy')}
                        />

                        <TextInput
                            withAsterisk
                            disabled
                            label="Үүсгэсэн хэрэглэгч нэр"
                            {...form.getInputProps('createdUserName')}
                        />

                        <Switch
                            label="Идэвхтэй эсэх"
                            {...form.getInputProps('isActive', { type: 'checkbox' })}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default EditUserSubscription;